module.exports = __webpack_public_path__ + "static/storyscript-f3e2d148b744f88f768bf47291710afa.png";